import {
  WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS,
  WHITE_LABEL_BUSINESS_USER_FETCH_ERROR,
} from "../types/index";

const defaultState = {
  users: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case WHITE_LABEL_BUSINESS_USER_FETCH_SUCCESS:
      return {
        ...state,
        users: action.payload,
      };

    default:
      return state;
  }
};
